var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_icon-menu-map",
    "data-name": " icon-menu-map",
    transform: "translate(-24.332 -206.806)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 36,
    height: 36,
    transform: "translate(24.332 206.806)",
    fill: "#fff",
    opacity: 0.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_38",
    "data-name": "\\u30D1\\u30B9 38",
    d: "M51.117,59.413a1.185,1.185,0,0,1-.54-.13q-.036-.019-.071-.04L42.818,54.85l-7.711,4.406a1.186,1.186,0,0,1-1.774-1.029V39.256a1.186,1.186,0,0,1,.6-1.029l8.281-4.732,0,0a1.183,1.183,0,0,1,.6-.164h0a1.183,1.183,0,0,1,.593.16l.013.008,7.644,4.368,6.5-4.336a1.186,1.186,0,0,1,1.843.987v18.97a1.186,1.186,0,0,1-.528.987L51.8,59.2q-.043.03-.088.056a1.18,1.18,0,0,1-.215.1h0a1.178,1.178,0,0,1-.336.059ZM44,52.8l5.928,3.388V39.944L44,36.557ZM35.7,39.944V56.184L41.633,52.8V36.557Zm16.6-.053v16.12l4.743-3.162V36.729Z",
    transform: "translate(-4.001 178.478)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMap);
export default __webpack_public_path__ + "static/media/icon-menu-map.544d320fa6a9ca67a73be3c4291ae560.svg";
export { ForwardRef as ReactComponent };